import { ReconnectSquare } from './ReconnectSquare';
import { ASSISTANT_NAME } from '../brand.js';

export function OnboardingIntro() {
  return <><p class="setup-eyebrow">YOUR SERVICES. YOUR TEAM.</p><h2>Bring your salon over from Square.</h2>
    <p>Connect the Square business you use for this salon. {ASSISTANT_NAME} will read your services, team and availability so you don’t have to enter them again.</p>
    <p>You’ll sign in securely with Square, then return here to choose your location. Connecting doesn’t publish your booking page.</p>
    <ReconnectSquare guided label="Connect Square" />
  </>;
}
